import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate, creatDownload } from '@/utils/formUtils'
import {
  compare,
  getdayType,
  cycleChange,
  getDeliveryType
} from 'enumeration/lab-order.js'
import billDatas from '@/store/actions/datas/bill'
import { trustDeedList } from 'json/trust-deed'
import { getEnumeration } from 'enumeration'
import orderflowHelper from '@/config/order'
import { getPlateType } from '@/utils/plateType'

export default {
  getBillList(ctx, data) {
    return fetch.getBillList(data).then(res => {
      res.data.forEach(ele => {
        ele = billDatas.formatBillDetail(ele)
      })
      return getTotalNumber(res)
    })
  },
  getBatchBillList(ctx, data) {
    return fetch.getBatchBillList(data).then(res => {
      res.data.forEach(ele => {
        ele = billDatas.formatBillDetail(ele)
      })
      return getTotalNumber(res)
    })
  },
  createBatchBill(ctx, data) {
    return fetch.createBatchBill(data).then(res => {
      return res
    })
  },
  createBill(ctx, data) {
    data.workflow = 'LAB_BILL_CREATED'
    return fetch.createBill(data).then(res => {
      return res.data
    })
  },
  billImportOrder(ctx, data) {
    data.workflow = 'LAB_BILL_ORDER_IMPORT'
    return fetch.createBill(data).then(res => {
      return res
    })
  },
  updateBill(ctx, data) {
    return fetch.updateBill(data).then(res => {
      return res
    })
  },
  getBill(ctx, id) {
    return fetch.getBill(id).then(res => {
      return billDatas.formatBillDetail(res.data)
    })
  },
  deleteBill(ctx, id) {
    return fetch.deleteBill(id).then(res => {
      return res.data
    })
  },
  handleSettle(ctx, data) {
    data.operType = 'SETTLEMENT'
    return fetch.billOtherUpdate(data).then(res => {
      return res.data
    })
  },
  handleInvoice(ctx, data) {
    data.operType = 'INVOICE'
    return fetch.billOtherUpdate(data).then(res => {
      return res.data
    })
  },
  handleMailed(ctx, data) {
    data.operType = 'MAILED'
    return fetch.billOtherUpdate(data).then(res => {
      return res.data
    })
  },
  handleDelay(ctx, data) {
    data.operType = 'DELAY'
    return fetch.billOtherUpdate(data).then(res => {
      return res.data
    })
  },
  closeBill(ctx, data) {
    return fetch.closeBill(data).then(res => {
      return res.data
    })
  },
  billsExportExcel(ctx, data) {
    return fetch.billsExportExcel(data).then(res => {
      return res.data
    })
  },
  billsExportPdf(ctx, data) {
    return fetch.billsExportPdf(data).then(res => {
      return res.data
    })
  },
  billsExportReport (ctx, data) {
    return fetch.billsExportReport(data).then(res => {
      return res.data
    })
  },
  updateBillStatus(ctx, data) {
    return fetch.updateBillStatus(data).then(res => {
      return res
    })
  },
  removeOrders(ctx, data) {
    return fetch.removeOrders(data).then(res => {
      return res.data
    })
  },
  assginPre(ctx, data) {
    return fetch.assginPre(data).then(res => {
      return res.data
    })
  },
  getAssginPre(ctx, data) {
    return fetch.getAssginPre(data).then(res => {
      res.data = res.data.map(e => e.order)
      res.data.forEach(ele => {
        ele = billDatas.formatSampleDetail(ele)
      })
      return getTotalNumber(res)
    })
  },
  addAssginPre(ctx, data) {
    return fetch.addAssginPre(data).then(res => {
      return res.data
    })
  },
  deleteAssginPre(ctx, data) {
    return fetch.deleteAssginPre(data).then(res => {
      return res.data
    })
  },
  getOrderCountByBill(ctx, data) {
    return fetch.getOrderCountByBill(data).then(res => {
      return res.data
    })
  },
  addExistOrderToBill(ctx, data) {
    return fetch.addExistOrderToBill(data).then(res => {
      return res.data
    })
  },
  addNewOrdersToBill(ctx, data) {
    return fetch.addNewOrdersToBill(data).then(res => {
      return res.data
    })
  },
  billPendingTasksSubmit(ctx, data) {
    return fetch.billPendingTasksSubmit(data).then(res => {
      return res
    })
  },
  getRecollectOrders(ctx, data) {
    return fetch.getRecollectOrders(data).then(res => {
      res.data.forEach(ele => {
        ele = billDatas.formatSampleDetail(ele)
      })
      return res.data
    })
  },
  recollectOrdersByBill(ctx, data) {
    return fetch.recollectOrdersByBill(data).then(res => {
      return res
    })
  },
  updateBatchBillStatus(ctx, data) {
    return fetch.updateBatchBillStatus(data).then(res => {
      return res
    })
  },
  callNotice(ctx, data) {
    return fetch.callNotice(data).then(res => {
      return res
    })
  },
  copyBills (ctx, id) {
    return fetch.copyBills(id).then(res => {
      return res
    })
  },
  deleteBills (ctx, ids) {
    return fetch.deleteBills(ids).then(res => {
      return res
    })
  }
}